import React, { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingIndicator, FModal, Button } from '@components';
import { toast } from 'react-toastify';
import { getRequerimentosStatus } from '../../../../store/requerimentos/thunks';
import { RequerimentoService } from '../../../../common/services/requerimento';

const CardIndeferido = ({ requerimento, formObj }) => {
  const [openModal, setOpenModal] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const { data: { matricula, token } = { matricula: '', token: '' } } =
    useSelector((state) => state.user);

  function baixarArquivoPDF(protocolo) {
    try {
      const service = new RequerimentoService();
      setLoadingPDF(true);
      service
        .gerarPDFRequerimento({
          matricula,
          protocolo,
          token,
        })
        .then((res) => {
          const blob = new Blob([res], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Requerimento - ${protocolo}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setLoadingPDF(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar o PDF do requerimento`);
    }
  }

  return (
    <>
      <div className="card">
        <div className="card-body card-deferidos-e-indeferidos ">
          <div>
            <Button
              onClick={() => baixarArquivoPDF(requerimento.Protocolo)}
              disabled={loadingPDF}
              className="simpleLink ts-14"
            >
              {loadingPDF ? 'Carregando...' : `Nº:${requerimento.Protocolo}`}
            </Button>
            <h1 className="ts-20 fw-bold">{formObj.nome}</h1>
          </div>
          <div>
            <Button onClick={() => setOpenModal(true)}>
              Mostrar motivo do indeferimento
            </Button>
          </div>
          <div>
            <p className="text-muted ts-14 text-nowrap">Solicitado em</p>
            <p className="ts-14 fw-bold">
              {format(new Date(requerimento.DataCriacao), 'dd/MM/yyyy')}
            </p>
          </div>
        </div>
      </div>
      <FModal isOpen={openModal} close onClose={() => setOpenModal(false)}>
        <h3 className="mb-3">Motivo(s):</h3>
        {requerimento.Motivo.split(';').map((m) => (
          <p key={m} className="mb-2 ts-14 fw-bold">
            {m};
          </p>
        ))}
      </FModal>
    </>
  );
};

export const Indeferidos = () => {
  const dispatch = useDispatch();
  const indeferidos = useSelector((state) => state.requerimentos.indeferido);
  const isLoading = useSelector((state) => state.requerimentos.loadingStatus);
  const formularios = useSelector(
    (state) => state.requerimentos.allFormsLabels
  );

  useEffect(() => {
    dispatch(getRequerimentosStatus({ status: 'indeferido' }));
  }, [dispatch]);

  return isLoading ? (
    <LoadingIndicator />
  ) : (
    <div className="card-deferidos-e-indeferidos-container">
      {indeferidos.map((requerimento) => {
        const formObj = formularios.find((valor) => {
          return valor.referencia === requerimento.Formulario;
        });

        return (
          formObj && (
            <CardIndeferido
              key={`${requerimento.Protocolo}-${
                requerimento.DataCriacao ?? ''
              }`}
              formObj={formObj}
              requerimento={requerimento}
            />
          )
        );
      })}
      {indeferidos.length === 0 && (
        <div className="card">
          <div className="card-body">
            <p>Você não possui requerimentos indeferidos</p>
          </div>
        </div>
      )}
    </div>
  );
};
